import { Matcher, MatchResponse } from 'interweave';
import FormBuilder from './FormBuilder';

export class FormShortcodeMatcher extends Matcher {
  constructor() {
    super('form', {
      tagName: 'div',
    });
  }

  match(value: string) {
    // Match [form ...] shortcodes
    const regex = /\[form[^\]]*\]/gi;
    const match = regex.exec(value);

    if (!match) {
      return null;
    }

    return {
      match: match[0],
      index: match.index,
      length: match[0].length,
      valid: true,
    };
  }

  replaceWith(children: string) {
    return <FormBuilder shortcode={children} />;
  }

  asTag(): string {
    return 'div';
  }
}

export default FormShortcodeMatcher;
